<template>
  <el-dialog :title="title" :visible.sync="visible" width="60%" append-to-body @closed="handleClosed">
    <el-table
      ref="importTable"
      :data="tableData"
      border
      max-height="450"
      @selection-change="handleSelectionChange"
      v-loading="loading"
      element-loading-text="正在解析文件..."
      :cell-style="{ padding: '4px 0' }"
    >
      <el-table-column type="selection" width="50" align="center" />
      <!-- <el-table-column prop="coupon_uuid" label="优惠券编码" width="160" /> -->
      <el-table-column prop="mobile" label="手机号" width="140" />
      <el-table-column prop="nick_name" label="昵称" />
      <!-- <el-table-column prop="user_uuid" label="用户 UUID" width="180" show-overflow-tooltip /> -->
      <el-table-column prop="issue_date" label="发放时间" width="160" show-overflow-tooltip />
      <el-table-column prop="is_issued" label="是否已使用" width="120" align="center">
        <template slot-scope="scope">
          <span :class="scope.row.is_issued === 'N' ? 'valid' : 'invalid'">
            {{ scope.row.is_issued === "N" ? "未使用" : "已使用" }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" :disabled="!selectedRows.length" :loading="saving" @click="confirm">
        {{ confirmText }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "ImportDataDialog",
    data() {
      return {
        visible: false,
        loading: false,
        saving: false,
        tableData: [],
        selectedRows: [],
        title: "导入名单",
        confirmText: "确定",
        width: "80%",
      };
    },
    methods: {
      open(options = {}) {
        const { data = [], loading = false, title, confirmText, width } = options;
        this.title = title || "导入名单";
        this.confirmText = confirmText || "确定";
        this.width = width || "640px";
        this.visible = true;
        this.setLoading(loading);
        this.setData(data);
      },
      close() {
        this.visible = false;
      },
      setLoading(value) {
        this.loading = !!value;
      },
      setData(data = []) {
        this.tableData = data;
        this.$nextTick(() => {
          this.clearSelection();
        });
      },
      clearSelection() {
        this.selectedRows = [];
        this.$refs.importTable && this.$refs.importTable.clearSelection();
      },
      handleSelectionChange(rows) {
        this.selectedRows = rows;
      },
      confirm() {
        if (!this.selectedRows.length) {
          this.$message.warning("请先选择名单");
          return;
        }
        this.saving = true;
        this.$emit("confirm", this.selectedRows, this.stopSaving);
      },
      stopSaving(success = true) {
        this.saving = false;
        if (success) {
          this.close();
        }
      },
      handleClosed() {
        this.loading = false;
        this.saving = false;
        this.clearSelection();
        this.$emit("closed");
      },
    },
  };
</script>

<style scoped>
  .valid {
    color: #67c23a;
  }

  .invalid {
    color: #f56c6c;
  }

  .dialog-footer {
    text-align: center;
    padding-bottom: 10px;
  }

  .dialog-footer .el-button {
    min-width: 110px;
  }
</style>
